import React from "react";
import ProSourceForm from "../../components/ProSourceForm";
import { Form, Row, Col, ListGroup } from "react-bootstrap";
import { BrandLogo } from "../BrandSetup";
import ImageUpload from "../../components/ImageUpload";
import {
  FormItem,
  RequiredAsterisk,
  InfoAlertHelper,
} from "../../components/Base";
import {
  getDefaultTimeSlots,
  GetSubmitClassList,
  getBatchValueOfTimeSlotLimits,
} from "../../helpers";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { DB_DATE_FORMAT, ITEM_DESCRIPTION_CHAR_LIMIT } from "../../constants";
import ItemTags from "./ItemTags";
import ApplyToAllField from "../../components/widgets/ApplyToAllField";
import moment from "moment";
import { isEmpty } from "lodash";

export default class ItemForm extends ProSourceForm {
  constructor(props) {
    super(props);
    const {
        item = {},
        noCategory = false,
        isConciergeItem = false,
        store = {},
      } = this.props,
      {
        category = "",
        item_id = {},
        available = true,
        visible = false,
        hotItem = false,
        item_limit_per_day = 0,
        item_limit_per_time_slot = [],
      } = item,
      {
        name = "",
        description = "",
        price = "",
        image_url = "",
        _id = "",
        extragroup = [],
        regular_price = "",
        discount_type = "",
        discount_value = "",
        active_discount = "",
        discounted_price = "",
        discount_description = "",
        isMealPlan = false,
        isBulk = false,
        off_dates = [],
        isVisibleOnOffDate = false,
        isDineInExclusive = false,
        exclusives = [],
        isExclusive = false,
      } = item_id;

    const { categories = [] } = store;
    let selected_category = [];
    if (!isEmpty(item._id)) {
      selected_category = categories.filter(
        (cat) => cat.category_name === category,
      );
    }

    const today_date = moment(new Date()).format(DB_DATE_FORMAT);
    this.state = {
      values: {
        name,
        description,
        price,
        discount_toggle: Number(active_discount) === 0 ? false : true,
        regular_price,
        discount_type,
        discount_value,
        active_discount,
        discounted_price,
        discount_description,
        isMealPlan,
        isBulk,
        category,
        image_url,
        _id,
        available,
        visible,
        hotItem,
        item_limit_per_day: item_limit_per_day == null ? 0 : item_limit_per_day,
        extragroup: extragroup.filter((it) => !isEmpty(it._id)),
        item_limit_per_time_slot,
        item_limit_per_time_slot_batch: getBatchValueOfTimeSlotLimits(
          item_limit_per_time_slot,
        ),
        tags:
          typeof this.props.item !== "undefined" &&
          this.props.item.item_id &&
          this.props.item.item_id.tags
            ? this.props.item.item_id.tags
            : [],
        tag_settings: this.props.store?.tag_settings,
        apply_to_all: false,
        isUnavailableToday: off_dates.includes(today_date),
        isVisibleOnOffDate,
        off_dates,
        userId: this.props.userId,
        role: this.props.role,
        image_updated: false,
        isDineInExclusive,
        exclusives,
        isExclusive,
      },
      today_date,
      changedValues: [],
      errors: {},
      touched: {},
      isSubmitting: false,
      file: null,
      itemDescriptionCharCount: description.length,
      discountDescriptionCharCount: discount_description.length,
      showVisibilityToggle: !available,
      isCategoryExclusive:
        !isEmpty(selected_category) && !isEmpty(item._id)
          ? selected_category[0].isExclusive
          : false,
    };

    this.validate = isConciergeItem
      ? { required: ["name", "regular_price"] }
      : {
          required: noCategory
            ? ["name", "regular_price", "image_url"]
            : ["name", "regular_price", "category", "image_url"],
        };

    this.afterSubmit = this.afterSubmit.bind(this);
    this.handleOnClickCancelBtn = this.handleOnClickCancelBtn.bind(this);
    this.handleOnBlurCategory = this.handleOnBlurCategory.bind(this);
    this.handleOnClickDeleteBtn = this.handleOnClickDeleteBtn.bind(this);
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.item?.item_id?._id || prevProps.item?._id;
    const currentId = this.props.item?.item_id?._id || this.props.item?._id;
    if (currentId !== prevId) {
      const { item = {}, store = {} } = this.props,
        {
          category = "",
          item_id = {},
          available = true,
          visible = false,
          hotItem = false,
          item_limit_per_day = 0,
          item_limit_per_time_slot = [],
        } = item,
        {
          name = "",
          description = "",
          price = "",
          image_url = "",
          _id = "",
          extragroup = [],
          regular_price = "",
          discount_type = "",
          discount_value = "",
          active_discount = "",
          discounted_price = "",
          discount_description = "",
          isMealPlan = false,
          isBulk = false,
          off_dates = [],
          isVisibleOnOffDate = false,
          isDineInExclusive = false,
          exclusives = [],
          isExclusive = false,
        } = item_id;

      const { categories = [] } = store;
      let selected_category = [];
      if (!isEmpty(item._id)) {
        selected_category = categories.filter(
          (cat) => cat.category_name === category,
        );
      }

      const today_date = moment(new Date()).format(DB_DATE_FORMAT);
      this.setState({
        values: {
          name,
          description,
          price,
          discount_toggle: Number(active_discount) === 0 ? false : true,
          regular_price,
          discount_type,
          discount_value,
          active_discount,
          discounted_price,
          discount_description,
          isMealPlan,
          isBulk,
          category,
          image_url,
          _id,
          available,
          visible,
          hotItem,
          item_limit_per_day:
            item_limit_per_day == null ? 0 : item_limit_per_day,
          extragroup: extragroup.filter((it) => !isEmpty(it._id)),
          item_limit_per_time_slot,
          item_limit_per_time_slot_batch: getBatchValueOfTimeSlotLimits(
            item_limit_per_time_slot,
          ),
          tags:
            typeof this.props.item !== "undefined" &&
            this.props.item.item_id &&
            this.props.item.item_id.tags
              ? this.props.item.item_id.tags
              : [],
          tag_settings: this.props.store?.tag_settings,
          apply_to_all: false,
          isUnavailableToday: off_dates.includes(today_date),
          isVisibleOnOffDate,
          off_dates,
          userId: this.props.userId,
          role: this.props.role,
          image_updated: false,
          isDineInExclusive,
          exclusives,
          isExclusive,
        },
        today_date,
        changedValues: [],
        errors: {},
        touched: {},
        isSubmitting: false,
        file: null,
        itemDescriptionCharCount: description.length,
        discountDescriptionCharCount: discount_description.length,
        showVisibilityToggle: !available,
        isCategoryExclusive:
          !isEmpty(selected_category) && !isEmpty(item._id)
            ? selected_category[0].isExclusive
            : false,
      });
    }
  }

  handleOnClickCancelBtn = () => {
    if (this.props.onClickCancelBtn) {
      this.props.onClickCancelBtn();
    } else if (this.props.onHide) {
      this.props.onHide();
    }
  };

  handleOnClickDeleteBtn = () => {
    this.props.onClickDeleteBtn &&
      this.props.onClickDeleteBtn(this.state.values.apply_to_all);
  };

  handleOnBlurCategory = () => {
    this.setStateKey("touched", "category", "true");
    this.validateForm();
  };

  handleOnChange = (event) => {
    const target = event.target,
      value = target.value,
      name = target.name;

    let { values } = this.state;

    if (values[name] !== value) {
      this.updateChanges(name, value, event);
    }

    if (
      name === "description" &&
      value !== "" &&
      value.length > ITEM_DESCRIPTION_CHAR_LIMIT
    ) {
      // do nothing
    } else {
      values[name] = value;
      this.setState({ values });
    }

    if (
      name === "discount_description" &&
      value !== "" &&
      value.length > ITEM_DESCRIPTION_CHAR_LIMIT
    ) {
      // do nothing
    } else {
      values[name] = value;
      this.setState({ values });
    }

    this.setStateKey("touched", name, "true");
    this.validateForm();

    this.onChange && this.onChange(event);
  };

  validateLimitInput = (input) => {
    const newInput = String(input).replace(/[^0-9]/g, "");
    if (newInput.length > 7) {
      return newInput.slice(0, 6);
    } else {
      return newInput;
    }
  };

  onChange = (event) => {
    const target = event.target,
      checked = target.checked,
      name = target.name,
      value = target.value;
    let { values = {} } = this.state,
      state = {};
    let { errors = {} } = this.state;
    if (name === "available") {
      values[name] = checked;
      state.values = values;
      this.setState({ showVisibilityToggle: !checked });
    } else if (name === "visible") {
      values[name] = checked;
      state.values = values;
    } else if (name === "hotItem") {
      values[name] = checked;
      state.values = values;
    } else if (name === "description") {
      state.itemDescriptionCharCount = values.hasOwnProperty("description")
        ? values.description.length
        : 0;
      if (state.itemDescriptionCharCount > ITEM_DESCRIPTION_CHAR_LIMIT) {
        errors["description"] = "Description character limit exceeded.";
      } else {
        delete errors["description"];
      }
      this.setState({ errors });
    } else if (name === "discount_description") {
      state.discountDescriptionCharCount = values.hasOwnProperty(
        "discount_description",
      )
        ? values.discount_description.length
        : 0;
      if (state.discountDescriptionCharCount > ITEM_DESCRIPTION_CHAR_LIMIT) {
        errors["discount_description"] =
          "Description character limit exceeded.";
      } else {
        delete errors["discount_description"];
      }
      this.setState({ errors });
    } else if (name === "item_limit_per_time_slot_batch") {
      let {
        item_limit_per_time_slot = [],
        item_limit_per_time_slot_batch,
        item_limit_per_day,
      } = values;
      if (!isEmpty(item_limit_per_time_slot_batch)) {
        if (
          Number(item_limit_per_day) !== 0 &&
          Number(item_limit_per_day) < Number(item_limit_per_time_slot_batch)
        ) {
          errors["item_limit_per_time_slot_batch"] =
            "Value is more than daily limit";
          state.errors = errors;
        } else {
          delete errors["item_limit_per_time_slot_batch"];

          if (item_limit_per_time_slot.length === 0) {
            item_limit_per_time_slot = getDefaultTimeSlots(this.props.store);
          }
          const validateInput = this.validateLimitInput(value);

          values.item_limit_per_time_slot = item_limit_per_time_slot.map(
            (i) => {
              i.limit = parseInt(validateInput);
              return i;
            },
          );

          values.item_limit_per_time_slot_batch = parseInt(validateInput);
          state.values = values;
        }
      } else {
        errors["item_limit_per_time_slot_batch"] = "Invalid input";
        state.errors = errors;
      }
    } else if (name === "item_limit_per_day") {
      let { item_limit_per_day, item_limit_per_time_slot_batch, category } =
        values;
      if (!isEmpty(item_limit_per_day)) {
        const { store } = this.props;
        const { categories = [] } = store || {};
        const selectedCategory = categories.filter(
          (cat) => cat.category_name === category,
        );

        if (!isEmpty(selectedCategory[0])) {
          if (
            Number(item_limit_per_day) !== 0 &&
            selectedCategory[0].category_limit_per_day > 0 &&
            Number(item_limit_per_day) >
              selectedCategory[0].category_limit_per_day
          ) {
            errors["item_limit_per_day"] =
              "Item limit cannot be more than category limit";
          } else if (
            Number(item_limit_per_day) === 0 ||
            Number(item_limit_per_day) > Number(item_limit_per_time_slot_batch)
          ) {
            delete errors["item_limit_per_day"];
            delete errors["item_limit_per_time_slot_batch"];
          } else if (item_limit_per_time_slot_batch > item_limit_per_day) {
            errors["item_limit_per_time_slot_batch"] =
              "Value is more than daily limit";
          }
          state.errors = errors;
        } else {
          delete errors["item_limit_per_day"];
          values.item_limit_per_day = 0;
          const validateInput = this.validateLimitInput(value);

          values.item_limit_per_day = parseInt(validateInput);
          state.values = values;
        }
      } else {
        errors["item_limit_per_day"] = "Invalid input";
        state.errors = errors;
      }
    } else if (name === "discount_toggle") {
      values[name] = checked;
      state.values = values;
      this.computeDiscount();
    } else if (name === "isMealPlan") {
      values[name] = checked;

      if (checked) {
        values.item_limit_per_time_slot_batch = 0;
        values.item_limit_per_time_slot = getDefaultTimeSlots(this.props.store);
        values.item_limit_per_day = 0;
      }

      state.values = values;
    } else if (name === "isBulk") {
      values[name] = checked;
      state.values = values;
    } else if (name === "isUnavailableToday") {
      const { today_date = "" } = this.state;

      if (checked) {
        values["off_dates"].push(today_date);
      } else {
        const x = values["off_dates"].indexOf(today_date);

        if (x !== -1) {
          values["off_dates"].splice(x, 1);
        }
      }
      values[name] = checked;
      state.values = values;
    } else if (name === "isVisibleOnOffDate") {
      values[name] = checked;
      state.values = values;
    } else if (name === "isDineInExclusive") {
      values[name] = checked;
      if (this.state.values.isDineInExclusive) {
        values.exclusives.push("isDineInExclusive");
      } else {
        values.exclusives = values.exclusives.filter(
          (item) => item !== "isDineInExclusive",
        );
      }
      state.values = values;
    } else if (name === "name") {
      this.props.onVerifyName && this.props.onVerifyName(values.name);
    }

    this.setState(state);
  };

  setTagSettings = (args) => {
    this.setState((prevState) => {
      const newValues = { ...prevState.values };
      newValues.tag_settings = { ...args };
      return { values: newValues };
    });
  };

  setActiveTags = (args) => {
    this.setState((prevState) => {
      const newValues = { ...prevState.values };
      newValues.tags = [...args];
      return { values: newValues };
    });
  };

  setApplyToAll = (bool) => {
    this.setState((prevState) => {
      const newValues = { ...prevState.values };
      newValues.apply_to_all = bool;
      return { values: newValues };
    });
  };

  onSubmit = (values, setSubmitting) => {
    if (this.state.file) {
      this.props.uploadItemPhoto(
        { file: this.state.file, itemId: this.state.values._id },
        (filePath) => {
          values.image_url = filePath;
          this.setState({ values });
          setSubmitting(true);
          this.props.onSubmit(values, setSubmitting, this.afterSubmit);
        },
        setSubmitting,
      );
    } else {
      this.props.onSubmit(values, setSubmitting, this.afterSubmit);
    }
  };

  afterSubmit = () => {
    this.props.afterSubmit && this.props.afterSubmit();
  };

  onCheckBoxChange = (i, event, extraId) => {
    const target = event?.target;
    const _id = extraId || target?.getAttribute("_id");
    if (!_id) return;

    let { values } = this.state;
    let { extragroup = [] } = values;

    const group_index = extragroup.reduce(
      (acc, x, idx) => (x.extra_group_id._id === _id ? [...acc, idx] : acc),
      [],
    );

    if (isEmpty(group_index)) {
      extragroup.push({
        extra_group_id: { _id: _id },
      });
    } else {
      group_index.forEach((idx) => extragroup.splice(idx, 1));
    }
    values["extragroup"] = extragroup;
    this.setState({ values });
    this.updateChanges(
      "extra_groups",
      extragroup.length +
        (extragroup.length === 1 ? " checked item" : " checked items"),
    );
  };

  CheckExtrasGroup = (extras = []) => {
    let { values = {} } = this.state;
    let { extragroup = [] } = values;
    return extras.map((extra) => {
      const group_index = extragroup.findIndex(
        (x) => x.extra_group_id._id === extra._id,
      );
      if (group_index === -1) {
        return { ...extra, checked: false };
      } else {
        return { ...extra, checked: true };
      }
    });
  };

  initializeRegularPrice = () => {
    let { values = {} } = this.state;
    if (values.regular_price === "") {
      values.regular_price = values.price;
      this.setState({ values });
    }
  };

  onChangeRegularPrice = (e) => {
    let { values = {} } = this.state;
    values.regular_price = e.target.value;
    this.setState({ values });
    this.computeDiscount();
    this.updateChanges("regular_price", e.target.value);
    this.setStateKey("touched", "regular_price", "true");
    this.validateForm();
  };

  onChangeDiscountType = (e) => {
    let { values = {} } = this.state;
    values.discount_type = e.target.value;
    values.discount_value = 0;
    this.setState({ values });
    this.computeDiscount();
    this.updateChanges("discount_type", e.target.value);
  };

  onChangeDiscountValue = (e) => {
    let { values = {} } = this.state;
    values.discount_value = e.target.value;
    this.setState({ values });
    this.computeDiscount();
    this.updateChanges("discount_value", e.target.value);
  };

  onBlurPrices = () => {
    let { values = {} } = this.state;
    values.price = Number(values.price).toFixed(2);
    values.regular_price = Number(values.regular_price).toFixed(2);
    values.active_discount = Number(values.active_discount).toFixed(2);
    values.discounted_price = Number(values.discounted_price).toFixed(2);
    this.setStateKey("touched", "regular_price", "true");
    this.validateForm();
  };

  computeDiscount = () => {
    let { values = {} } = this.state;
    if (values.discount_toggle === false) {
      values.active_discount = 0;
      values.discount_value = 0;
      values.discount_type = "noDiscount";
      values.discount_description = "";
    } else {
      if (values.discount_type === "percentDiscount") {
        values.active_discount = Math.round(
          Number(values.discount_value * 0.01) * Number(values.regular_price),
        );
      } else if (values.discount_type === "rawDiscount") {
        values.active_discount = Number(values.discount_value);
      }
    }
    this.validateDiscount();
    values.discounted_price = values.regular_price - values.active_discount;
    values.price = values.discounted_price;
    this.setState({ values });
  };

  validateDiscount = () => {
    let { values = {} } = this.state;
    if (values.active_discount > values.regular_price)
      values.active_discount = 0;
    this.setState({ values });
  };

  componentDidMount() {
    this.initializeRegularPrice();
  }

  updateChanges = (name, value, event = "") => {
    if (
      [
        "available",
        "visible",
        "discount_toggle",
        "isUnavailableToday",
        "isVisibleOnOffDate",
        "isMealPlan",
        "isBulk",
      ].includes(name)
    ) {
      if (event) {
        value = event.target.checked ? "ON" : "OFF";
      }
    }
    this.setState((prevState) => ({
      ...prevState,
      changedValues: [
        ...prevState.changedValues.filter((e) => e.name !== name),
        { name, value },
      ],
    }));
  };

  render() {
    const actions = {
        handleFeedbackError: this.handleFeedbackError,
        isTouched: this.isTouched,
      },
      inputActions = {
        onChange: this.handleOnChange,
        onBlur: this.handleOnBlur,
      };

    const {
      noCategory = false,
      noAvailability = true,
      extras = [],
      origin = "",
      maxFileSize = 200,
      maxFileSizeText = "200KB",
      extraGroupErr = [],
      isConciergeItem = false,
    } = this.props;

    const { isCategoryExclusive = false, values } = this.state;
    const isEdit = values._id !== "";

    this.itemModalRef = React.createRef();
    this.limitFieldRef = React.createRef();
    this.extraGroupRef = React.createRef();

    return (
      <Form
        className="fv-plugins-bootstrap fv-plugins-framework item-modal-form"
        onSubmit={(event) => {
          event.preventDefault();
          setTimeout(() => {
            const { errors } = this.state;
            const keyErrors = Object.keys(errors);
            const itemInfoErr = [
              "name",
              "category",
              "image_url",
              "regular_price",
            ].filter((key) => keyErrors.includes(key));
            const limitErr = [
              "item_limit_per_time_slot_batch",
              "item_limit_per_day",
            ].filter((key) => keyErrors.includes(key));
            if (itemInfoErr.length > 0 && this.itemModalRef.current) {
              this.itemModalRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            } else if (limitErr.length > 0 && this.limitFieldRef.current) {
              this.limitFieldRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
            this.setAllFieldsToTouched();
            const isValid = this.validateForm();
            if (isEmpty(isValid)) {
              this.handleOnSubmit(event);
            }
          }, 50);
        }}
      >
        <style>{`
          .item-modal-form {
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow: hidden;
          }
          .item-modal-body-scroll {
            flex: 1 1 auto;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 1.25rem 1.5rem;
          }
          .item-modal-footer {
            flex: 0 0 auto;
            background: #fff;
            border-top: 1px solid #ebedf2;
            padding: 0.75rem 1.5rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 -3px 12px rgba(0, 0, 0, 0.05);
            z-index: 10;
          }
          .item-modal-body-scroll::-webkit-scrollbar {
            width: 6px;
          }
          .item-modal-body-scroll::-webkit-scrollbar-track {
            background: transparent;
          }
          .item-modal-body-scroll::-webkit-scrollbar-thumb {
            background: #d4dadf;
            border-radius: 4px;
          }
          .item-modal-body-scroll::-webkit-scrollbar-thumb:hover {
            background: #b5b5c3;
          }
          .extra-groups-scroll-container {
            max-height: 220px;
            overflow-y: auto;
            overflow-x: hidden;
          }
          .extra-groups-scroll-container::-webkit-scrollbar {
            width: 6px;
          }
          .extra-groups-scroll-container::-webkit-scrollbar-track {
            background: transparent;
          }
          .extra-groups-scroll-container::-webkit-scrollbar-thumb {
            background: #d4dadf;
            border-radius: 4px;
          }
        `}</style>

        <div className="item-modal-body-scroll">
          <Row ref={this.itemModalRef}>
            {/* Left Column: Visuals & Settings */}
            <Col lg={4} className="mb-4 mb-lg-0">
              {/* Photo Card */}
              <div className="card card-custom border bg-white mb-4">
                <div className="card-header py-3 px-4 border-bottom min-h-auto">
                  <div className="card-title my-0">
                    <h5 className="card-label font-size-h6 font-weight-bolder text-dark mb-0">
                      Item Photo {!isConciergeItem && <RequiredAsterisk />}
                    </h5>
                  </div>
                </div>
                <div className="card-body p-4 text-center">
                  {values.image_url ? (
                    <div className="d-flex flex-column align-items-center">
                      <BrandLogo
                        style={{
                          width: "160px",
                          height: "160px",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                        alt={"Item Photo"}
                        src={values.image_url}
                        onClickRemove={() => {
                          let { values: currValues = {} } = this.state;
                          currValues.image_url = "";
                          this.setState({ file: null, values: currValues });
                          this.updateChanges("image", "Removed");
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-xs btn-light-danger mt-2 font-weight-bold"
                        onClick={() => {
                          let { values: currValues = {} } = this.state;
                          currValues.image_url = "";
                          this.setState({ file: null, values: currValues });
                          this.updateChanges("image", "Removed");
                        }}
                      >
                        <i className="ki ki-bold-trash icon-xs mr-1"></i> Remove
                        Photo
                      </button>
                    </div>
                  ) : (
                    <ImageUpload
                      onError={this.props.actions?.onError}
                      onChange={(file, preview) => {
                        let { values: currValues = {} } = this.state;
                        currValues.image_url = preview;
                        currValues.image_updated = true;
                        this.setState({ file, values: currValues });
                        this.updateChanges("image", "Changed");
                      }}
                      label={
                        <div className="my-2">
                          <div className="text-muted font-size-xs">
                            Maximum file size: {maxFileSizeText}.<br />
                            Recommended: 250x250 or 200x200.
                          </div>
                          {this.handleFeedbackError(
                            "image_url",
                            "error-text",
                          ) && (
                            <div className="text-danger font-size-xs mt-1">
                              {this.handleFeedbackError(
                                "image_url",
                                "error-text",
                              )}
                            </div>
                          )}
                        </div>
                      }
                      maxFileSize={maxFileSize}
                      maxFileSizeText={maxFileSizeText}
                    />
                  )}
                </div>
              </div>

              {/* Availability & Settings Card */}
              {!noAvailability && (
                <div className="card card-custom border bg-white mb-4">
                  <div className="card-header py-3 px-4 border-bottom min-h-auto">
                    <div className="card-title my-0">
                      <h5 className="card-label font-size-h6 font-weight-bolder text-dark mb-0">
                        Availability & Settings
                      </h5>
                    </div>
                  </div>
                  <div className="card-body p-4">
                    {/* Item Available Toggle */}
                    <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
                      <div>
                        <label className="font-weight-bolder text-dark mb-0 d-block">
                          Item Available
                        </label>
                        <span className="text-muted font-size-xs">
                          {values.available
                            ? "Available in store"
                            : "Currently hidden/disabled"}
                        </span>
                      </div>
                      <span className="switch switch-outline switch-icon switch-primary">
                        <label className="mb-0">
                          <input
                            type="checkbox"
                            name="available"
                            checked={values.available ? true : false}
                            {...inputActions}
                          />
                          <span></span>
                        </label>
                      </span>
                    </div>

                    {/* Show in Store when Unavailable */}
                    {this.state.showVisibilityToggle && (
                      <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom bg-light-warning p-2 rounded">
                        <div>
                          <label className="font-weight-bolder text-dark mb-0 d-block">
                            Show in Store
                          </label>
                          <span className="text-muted font-size-xs">
                            Display as sold out
                          </span>
                        </div>
                        <span className="switch switch-outline switch-icon switch-primary">
                          <label className="mb-0">
                            <input
                              type="checkbox"
                              name="visible"
                              checked={values.visible ? true : false}
                              {...inputActions}
                            />
                            <span></span>
                          </label>
                        </span>
                      </div>
                    )}

                    {/* Unavailable Today */}
                    {!values.isMealPlan && !isConciergeItem && (
                      <>
                        <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
                          <div>
                            <label className="font-weight-bolder text-dark mb-0 d-block">
                              Unavailable Today
                            </label>
                            <span className="text-muted font-size-xs">
                              {moment(
                                this.state.today_date,
                                DB_DATE_FORMAT,
                              ).format("MMM D, YYYY")}
                            </span>
                          </div>
                          <span className="switch switch-outline switch-icon switch-primary">
                            <label className="mb-0">
                              <input
                                type="checkbox"
                                name="isUnavailableToday"
                                checked={
                                  values.isUnavailableToday ? true : false
                                }
                                disabled={!values.available}
                                {...inputActions}
                              />
                              <span></span>
                            </label>
                          </span>
                        </div>

                        {/* Show in Store on Off Date */}
                        {values.isUnavailableToday && (
                          <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom bg-light-warning p-2 rounded">
                            <div>
                              <label className="font-weight-bolder text-dark mb-0 d-block">
                                Show in Store Today
                              </label>
                              <span className="text-muted font-size-xs">
                                Display as sold out today
                              </span>
                            </div>
                            <span className="switch switch-outline switch-icon switch-primary">
                              <label className="mb-0">
                                <input
                                  type="checkbox"
                                  name="isVisibleOnOffDate"
                                  checked={
                                    values.isVisibleOnOffDate ? true : false
                                  }
                                  {...inputActions}
                                />
                                <span></span>
                              </label>
                            </span>
                          </div>
                        )}
                      </>
                    )}

                    {/* Meal Plan Item */}
                    {!isConciergeItem && (
                      <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
                        <div>
                          <label className="font-weight-bolder text-dark mb-0 d-block">
                            Meal Plan Item
                          </label>
                          <span className="text-muted font-size-xs">
                            Only shown for meal plan orders
                          </span>
                        </div>
                        <span
                          className={`switch switch-outline switch-icon ${
                            isCategoryExclusive
                              ? "switch-secondary"
                              : "switch-primary"
                          }`}
                        >
                          <label className="mb-0">
                            <input
                              type="checkbox"
                              name="isMealPlan"
                              checked={
                                values.isMealPlan || isCategoryExclusive
                                  ? true
                                  : false
                              }
                              disabled={isCategoryExclusive}
                              {...inputActions}
                            />
                            <span></span>
                          </label>
                        </span>
                      </div>
                    )}

                    {/* Bulk Item */}
                    {!isConciergeItem && (
                      <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
                        <div>
                          <label className="font-weight-bolder text-dark mb-0 d-block">
                            Bulk Item
                          </label>
                          <span className="text-muted font-size-xs">
                            Delivery restricted to cars
                          </span>
                        </div>
                        <span className="switch switch-outline switch-icon switch-primary">
                          <label className="mb-0">
                            <input
                              type="checkbox"
                              name="isBulk"
                              checked={values.isBulk ? true : false}
                              {...inputActions}
                            />
                            <span></span>
                          </label>
                        </span>
                      </div>
                    )}

                    {/* Dine In Exclusive */}
                    {!isConciergeItem && (
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <label className="font-weight-bolder text-dark mb-0 d-block">
                            Dine In Exclusive
                          </label>
                          <span className="text-muted font-size-xs">
                            Available only for dine-in
                          </span>
                        </div>
                        <span className="switch switch-outline switch-icon switch-primary">
                          <label className="mb-0">
                            <input
                              type="checkbox"
                              name="isDineInExclusive"
                              checked={values.isDineInExclusive ? true : false}
                              {...inputActions}
                            />
                            <span></span>
                          </label>
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Tags Card */}
              {!isConciergeItem && (
                <div className="card card-custom border bg-white mb-4">
                  <div className="card-header py-3 px-4 border-bottom min-h-auto">
                    <div className="card-title my-0">
                      <h5 className="card-label font-size-h6 font-weight-bolder text-dark mb-0">
                        Item Tags
                      </h5>
                    </div>
                  </div>
                  <div className="card-body p-4">
                    <ItemTags
                      setTagSettings={this.setTagSettings}
                      setActiveTags={this.setActiveTags}
                      tags={this.state.values.tags}
                      tagSettings={this.state.values.tag_settings}
                      updateChanges={this.updateChanges}
                    />
                  </div>
                </div>
              )}
            </Col>

            {/* Right Column: Information, Pricing, Limits, Extras */}
            <Col lg={8}>
              {/* Basic Information Card */}
              <div className="card card-custom border bg-white mb-4">
                <div className="card-header py-3 px-4 border-bottom min-h-auto">
                  <div className="card-title my-0">
                    <h5 className="card-label font-size-h6 font-weight-bolder text-dark mb-0">
                      Basic Information
                    </h5>
                  </div>
                </div>
                <div className="card-body p-4">
                  <FormItem
                    customFormControl
                    name={"name"}
                    label={"Item Name"}
                    inputProps={{
                      name: "name",
                      placeholder: "e.g. Classic Cheeseburger",
                      value: values["name"],
                    }}
                    actions={actions}
                    inputActions={inputActions}
                    type={"text"}
                    normal
                    custom={
                      <Form.Control
                        name="name"
                        maxLength={50}
                        placeholder="e.g. Classic Cheeseburger"
                        value={values["name"]}
                        {...(actions.isTouched("name") && {
                          isValid: this.props.isNameValid,
                          isInvalid: !this.props.isNameValid,
                        })}
                        {...inputActions}
                      />
                    }
                    helperText={
                      <div>
                        {this.props.isVerifying && (
                          <div className="text-primary font-size-xs">
                            Validating name...
                          </div>
                        )}
                        {!this.props.isVerifying &&
                          actions.isTouched("name") &&
                          !this.props.isNameValid &&
                          !isEmpty(values.name) && (
                            <div className="text-danger font-size-xs">
                              Item name already exists
                            </div>
                          )}
                      </div>
                    }
                  />

                  <FormItem
                    customFormControl
                    label={"Description"}
                    name={"description"}
                    actions={actions}
                    custom={
                      <>
                        <Form.Control
                          as={"textarea"}
                          rows={3}
                          name="description"
                          placeholder="Describe the item, ingredients, or preparation"
                          value={values["description"]}
                          {...inputActions}
                        />
                        <div className="d-flex justify-content-end mt-1">
                          <span className="font-size-xs text-muted">
                            {this.state.itemDescriptionCharCount}/
                            {ITEM_DESCRIPTION_CHAR_LIMIT}
                          </span>
                        </div>
                      </>
                    }
                    normal
                  />

                  <Row>
                    <Col sm={6}>
                      <FormItem
                        label={"Regular Price"}
                        name={"regular_price"}
                        prepend={
                          <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bolder font-size-sm py-0 px-3 bg-light">
                              ₱
                            </span>
                          </div>
                        }
                        inputProps={{
                          name: "regular_price",
                          placeholder: "0.00",
                          min: 0,
                          step: "any",
                          value: values["regular_price"],
                        }}
                        inputActions={{
                          ...inputActions,
                          onChange: this.onChangeRegularPrice,
                          onBlur: this.onBlurPrices,
                        }}
                        actions={actions}
                        type={"number"}
                        showRequired={true}
                        normal
                      />
                    </Col>
                    <Col sm={6}>
                      {!noCategory && !isConciergeItem ? (
                        <FormItem
                          customFormControl
                          label={"Category"}
                          name={"category"}
                          className={"form-control-solid"}
                          actions={actions}
                          type={"text"}
                          showRequired={true}
                          custom={
                            <Typeahead
                              placeholder={"Select or type category"}
                              onChange={(selected) => {
                                let { values: currVals = {}, errors = {} } =
                                  this.state;
                                const { store } = this.props;
                                const { categories = [] } = store || {};
                                const restrictedchars = ["$", "."];
                                let newValue = "";
                                if (
                                  selected !== undefined &&
                                  selected.length > 0
                                ) {
                                  newValue =
                                    typeof selected[0] === "string"
                                      ? selected[0]
                                      : selected[0].label;
                                  currVals.category = newValue;
                                  const labelSplit =
                                    currVals.category.split("") || [];
                                  for (const char of restrictedchars) {
                                    if (labelSplit.includes(char)) {
                                      errors["category"] =
                                        '"$" and "." is not allowed';
                                      break;
                                    }
                                    if (errors["category"])
                                      delete errors["category"];
                                  }
                                  const selectedCategory = categories.filter(
                                    (cat) => cat.category_name === selected[0],
                                  );
                                  if (currVals.item_limit_per_day > 0) {
                                    if (
                                      selectedCategory[0] &&
                                      selectedCategory[0]
                                        .category_limit_per_day <
                                        currVals.item_limit_per_day
                                    ) {
                                      errors["item_limit_per_day"] =
                                        "Item limit cannot be more than category limit";
                                    }
                                  } else {
                                    delete errors["item_limit_per_day"];
                                  }
                                  currVals.isMealPlan =
                                    selectedCategory[0] &&
                                    selectedCategory[0].isExclusive;
                                  this.setState({
                                    values: currVals,
                                    errors,
                                    isCategoryExclusive:
                                      selectedCategory[0] &&
                                      selectedCategory[0].isExclusive,
                                  });
                                } else {
                                  currVals.category = "";
                                  this.setState({ values: currVals });
                                }
                                this.updateChanges("category", newValue);
                              }}
                              options={this.props.categories}
                              allowNew={true}
                              id={"categories_ta"}
                              onBlur={this.handleOnBlurCategory}
                              isValid={Boolean(
                                this.isTouched("category") &&
                                  this.getError("category") === "",
                              )}
                              isInvalid={this.getError("category") !== ""}
                              defaultInputValue={values.category}
                              newSelectionPrefix={"New Category: "}
                              filterBy={(option, state) => {
                                if (state.selected.length) return true;
                                if (
                                  option
                                    .toLowerCase()
                                    .indexOf(state.text.toLowerCase()) > -1
                                ) {
                                  state.allowNew = false;
                                }
                                return (
                                  option
                                    .toLowerCase()
                                    .indexOf(state.text.toLowerCase()) > -1
                                );
                              }}
                              emptyLabel={
                                <div style={{ whiteSpace: "break-spaces" }}>
                                  No matches found - type to add new category
                                </div>
                              }
                            />
                          }
                        />
                      ) : null}
                    </Col>
                  </Row>
                </div>
              </div>

              {/* Pricing & Discounts Card */}
              {!isConciergeItem && (
                <div className="card card-custom border bg-white mb-4">
                  <div className="card-header py-3 px-4 border-bottom min-h-auto d-flex align-items-center justify-content-between">
                    <div className="card-title my-0">
                      <h5 className="card-label font-size-h6 font-weight-bolder text-dark mb-0">
                        Discount & Promotion
                      </h5>
                    </div>
                    <div className="d-flex align-items-center">
                      <label className="font-weight-bold text-dark mb-0 mr-3 font-size-sm">
                        Enable Discount:
                      </label>
                      <span className="switch switch-sm switch-outline switch-icon switch-primary">
                        <label className="mb-0">
                          <input
                            type="checkbox"
                            name="discount_toggle"
                            checked={values.discount_toggle ? true : false}
                            {...inputActions}
                          />
                          <span></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="card-body p-4">
                    {!values.discount_toggle ? (
                      <div className="p-3 rounded bg-light border border-light-dark d-flex align-items-center">
                        <i className="flaticon2-tag text-muted mr-3 font-size-lg"></i>
                        <span className="text-muted font-size-sm">
                          No active discount. Customer will be charged the
                          regular price of{" "}
                          <b>₱{Number(values.regular_price || 0).toFixed(2)}</b>
                          .
                        </span>
                      </div>
                    ) : (
                      <>
                        <Row className="mb-3">
                          <Col sm={6}>
                            <label className="font-weight-bold text-dark font-size-sm mb-2 d-block">
                              Discount Type
                            </label>
                            <div
                              className="radio-inline"
                              onChange={this.onChangeDiscountType}
                            >
                              <label className="radio radio-primary mr-4 font-size-sm">
                                <input
                                  type="radio"
                                  id="percent"
                                  name="discountType"
                                  value="percentDiscount"
                                  checked={
                                    values.discount_type === "percentDiscount"
                                  }
                                />
                                <span></span> Percentage (%)
                              </label>
                              <label className="radio radio-primary font-size-sm">
                                <input
                                  type="radio"
                                  id="raw"
                                  name="discountType"
                                  value="rawDiscount"
                                  checked={
                                    values.discount_type === "rawDiscount"
                                  }
                                />
                                <span></span> Fixed Amount (₱)
                              </label>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <FormItem
                              label={
                                values.discount_type === "percentDiscount"
                                  ? "Discount Value (%)"
                                  : "Discount Value (₱)"
                              }
                              name={"discount_value"}
                              prepend={
                                <div className="input-group-prepend">
                                  <span className="input-group-text font-weight-bolder font-size-sm py-0 px-3 bg-light">
                                    {values.discount_type === "percentDiscount"
                                      ? "%"
                                      : "₱"}
                                  </span>
                                </div>
                              }
                              inputProps={{
                                name: "discount_value",
                                placeholder: "0",
                                value: values["discount_value"],
                                min: 0,
                                step: "any",
                                disabled:
                                  values.discount_type === "noDiscount"
                                    ? "disabled"
                                    : "",
                              }}
                              inputActions={{
                                ...inputActions,
                                onChange: this.onChangeDiscountValue,
                                onBlur: this.onBlurPrices,
                              }}
                              actions={actions}
                              type={"number"}
                              normal
                            />
                            {values.discount_type === "percentDiscount" &&
                              Number(values.discount_value) > 100 && (
                                <div className="text-danger font-size-xs mt-1">
                                  Percentage discount cannot exceed 100%
                                </div>
                              )}
                            {values.discount_type === "rawDiscount" &&
                              Number(values.discount_value) >
                                Number(values.regular_price) && (
                                <div className="text-danger font-size-xs mt-1">
                                  Discount amount cannot exceed regular price
                                </div>
                              )}
                          </Col>
                        </Row>

                        {/* Computed Price Summary */}
                        <div className="p-3 rounded bg-light-success border border-success-o-30 mb-3 d-flex justify-content-between align-items-center">
                          <div>
                            <span className="text-muted font-size-xs d-block">
                              Price Calculation
                            </span>
                            <span className="font-size-sm text-dark">
                              Regular:{" "}
                              <b>
                                ₱{Number(values.regular_price || 0).toFixed(2)}
                              </b>{" "}
                              &minus; Discount:{" "}
                              <b>
                                ₱
                                {Number(values.active_discount || 0).toFixed(2)}
                              </b>
                            </span>
                          </div>
                          <div className="text-right">
                            <span className="text-muted font-size-xs d-block">
                              Final Selling Price
                            </span>
                            <span className="font-size-h6 font-weight-bolder text-success">
                              ₱{Number(values.discounted_price || 0).toFixed(2)}
                            </span>
                          </div>
                        </div>

                        <FormItem
                          customFormControl
                          label={"Discount Description"}
                          name={"discount_description"}
                          actions={actions}
                          custom={
                            <>
                              <Form.Control
                                as={"textarea"}
                                rows={2}
                                name="discount_description"
                                placeholder="e.g. 20% Off Weekend Special"
                                value={values["discount_description"]}
                                {...inputActions}
                              />
                              <div className="d-flex justify-content-end mt-1">
                                <span className="font-size-xs text-muted">
                                  {this.state.discountDescriptionCharCount}/
                                  {ITEM_DESCRIPTION_CHAR_LIMIT}
                                </span>
                              </div>
                            </>
                          }
                          normal
                        />
                      </>
                    )}
                  </div>
                </div>
              )}

              {/* Inventory & Limits Card */}
              {!isConciergeItem &&
                !values.isMealPlan &&
                origin !== "getting_started" && (
                  <div
                    className="card card-custom border bg-white mb-4"
                    ref={this.limitFieldRef}
                  >
                    <div className="card-header py-3 px-4 border-bottom min-h-auto">
                      <div className="card-title my-0">
                        <h5 className="card-label font-size-h6 font-weight-bolder text-dark mb-0">
                          Order Limits
                        </h5>
                      </div>
                    </div>
                    <div className="card-body p-4">
                      <InfoAlertHelper text="Set limits for this item on a daily or time slot basis. Set to 0 if there is no limit." />
                      <Row className="mt-2">
                        <Col sm={6}>
                          <FormItem
                            label={"Daily Limit"}
                            name={"item_limit_per_day"}
                            inputProps={{
                              name: "item_limit_per_day",
                              placeholder: "0",
                              min: 0,
                              value: values["item_limit_per_day"],
                            }}
                            inputActions={inputActions}
                            actions={actions}
                            type={"number"}
                            normal
                            helperText={
                              <span className="text-muted font-size-xs">
                                0 = unlimited daily
                              </span>
                            }
                          />
                        </Col>
                        <Col sm={6}>
                          <FormItem
                            label={"Per Time Slot Limit"}
                            name={"item_limit_per_time_slot_batch"}
                            inputProps={{
                              name: "item_limit_per_time_slot_batch",
                              placeholder: "0",
                              min: 0,
                              value: values["item_limit_per_time_slot_batch"],
                            }}
                            inputActions={inputActions}
                            actions={actions}
                            type={"number"}
                            normal
                            helperText={
                              <span className="text-muted font-size-xs">
                                0 = unlimited per slot
                              </span>
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}

              {/* Extra Groups Card */}
              {origin !== "getting_started" && (
                <div
                  className="card card-custom border bg-white mb-4"
                  ref={this.props.extraGroupRef || this.extraGroupRef}
                >
                  <div className="card-header py-3 px-4 border-bottom min-h-auto d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <h5 className="card-label font-size-h6 font-weight-bolder text-dark mb-0 mr-2">
                        Extra Groups
                      </h5>
                      <span className="badge badge-light-primary font-weight-bolder">
                        {values.extragroup.length} attached
                      </span>
                    </div>
                  </div>
                  <div className="card-body p-4">
                    <InfoAlertHelper text="Attach extra groups (e.g. Choice of Sauces, Drinks) for customers to customize this item." />
                    <div className="extra-groups-scroll-container mt-2">
                      {extras.length === 0 ? (
                        <div className="text-center py-6 text-muted font-size-sm">
                          No extra groups created for this store yet.
                        </div>
                      ) : (
                        <ListGroup className="list-group-flush border rounded">
                          {this.CheckExtrasGroup(extras).map((extra, i) => {
                            const isExtraGroupErr = (
                              extraGroupErr || []
                            ).filter((it) => it === extra.extra_group_code)[0];
                            const hasErr = !isEmpty(isExtraGroupErr);

                            return (
                              <ListGroup.Item
                                key={extra._id || i}
                                className={`py-3 px-4 d-flex align-items-center justify-content-between ${
                                  hasErr ? "bg-light-danger" : ""
                                }`}
                                style={{
                                  cursor: "pointer",
                                  transition: "background-color 0.15s ease",
                                }}
                                onClick={() =>
                                  this.onCheckBoxChange(
                                    i,
                                    { target: { checked: !extra.checked } },
                                    extra._id,
                                  )
                                }
                              >
                                <div className="d-flex align-items-center flex-grow-1 mr-3 min-w-0">
                                  <div
                                    className="d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
                                    style={{ width: "20px", height: "20px" }}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <label
                                      className="checkbox checkbox-primary checkbox-single mb-0"
                                      style={{
                                        margin: 0,
                                        padding: 0,
                                        width: "18px",
                                        height: "18px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        _id={extra._id}
                                        checked={extra.checked}
                                        onChange={(e) =>
                                          this.onCheckBoxChange(i, e, extra._id)
                                        }
                                      />
                                      <span style={{ top: 0, left: 0 }}></span>
                                    </label>
                                  </div>
                                  <span
                                    className={`font-weight-bolder font-size-sm text-truncate ${
                                      hasErr ? "text-danger" : "text-dark"
                                    }`}
                                    title={extra.name}
                                  >
                                    {extra.name}
                                  </span>
                                </div>
                                <div
                                  className="d-flex align-items-center justify-content-end flex-shrink-0 flex-nowrap"
                                  style={{ gap: "6px" }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <span
                                    className="label label-warning label-inline font-weight-bolder text-nowrap"
                                    style={{
                                      height: "auto",
                                      minHeight: "22px",
                                      padding: "3px 8px",
                                      fontSize: "0.75rem",
                                      lineHeight: "1.2",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {extra.maximum_number} MAX
                                  </span>
                                  {extra.minimum_number === 0 ? (
                                    <span
                                      className="label label-primary label-inline font-weight-bolder text-nowrap"
                                      style={{
                                        height: "auto",
                                        minHeight: "22px",
                                        padding: "3px 8px",
                                        fontSize: "0.75rem",
                                        lineHeight: "1.2",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      OPTIONAL
                                    </span>
                                  ) : (
                                    <span
                                      className="label label-info label-inline font-weight-bolder text-nowrap"
                                      style={{
                                        height: "auto",
                                        minHeight: "22px",
                                        padding: "3px 8px",
                                        fontSize: "0.75rem",
                                        lineHeight: "1.2",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {extra.minimum_number} REQUIRED
                                    </span>
                                  )}
                                </div>
                              </ListGroup.Item>
                            );
                          })}
                        </ListGroup>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>

        {/* Sticky Action Footer */}
        <div className="item-modal-footer">
          <div className="d-flex align-items-center">
            {this.props.showDeleteButton ? (
              <button
                type="button"
                disabled={this.props.deleteLoading}
                className={GetSubmitClassList(
                  this.props.deleteLoading,
                  "btn btn-light-danger font-weight-bold px-5 py-2 mr-3",
                )}
                onClick={this.handleOnClickDeleteBtn}
              >
                <i className="ki ki-bold-trash icon-sm mr-1"></i>
                <span>Delete</span>
              </button>
            ) : null}
            {(this.props.role !== "console_user" ||
              window.location.pathname.includes("create-concierge")) && (
              <div className="d-inline-block">
                <ApplyToAllField
                  changes={this.state.changedValues}
                  storeCount={this.props.store?.store_count}
                  setApplyToAll={this.setApplyToAll}
                  method={this.props.method}
                />
              </div>
            )}
          </div>
          <div className="d-flex align-items-center">
            {this.props.showCancelButton ? (
              <button
                type="button"
                disabled={this.state.isSubmitting}
                className="btn btn-light-dark font-weight-bold px-6 py-2 mr-3"
                onClick={this.handleOnClickCancelBtn}
              >
                <span>Cancel</span>
              </button>
            ) : null}
            <button
              type="submit"
              disabled={this.state.isSubmitting}
              className={GetSubmitClassList(
                this.state.isSubmitting,
                "btn btn-primary font-weight-bold px-7 py-2",
              )}
            >
              <span>{isEdit ? "Save Changes" : "Add Item"}</span>
            </button>
          </div>
        </div>
      </Form>
    );
  }
}
